import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/fms/fms_spjs`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}
 
function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_spjs/${id}`, options)
    .then(response => {
      let spj = jsona.deserialize(response.data);
      delete spj.links;
      return spj;
    });
}

function add(spjs) {
  
  console.log(spjs);
  const payload = jsona.serialize({
    stuff: spjs,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/fms/fms_spjs`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(spj) {
  const payload = jsona.serialize({
    stuff: spj,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };
 
  return axios.patch(`${url}/fms/fms_spjs/${spj.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update_bulk(spjs) {
  
  console.log(spjs);
  const payload = jsona.serialize({
    stuff: spjs,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/fms/fms_spjs/bulk_update`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/fms/fms_spjs/${id}`, options);
}

function last_no() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_spjs/last/no`, options)
    .then(response => {
      return response.data;
    });
}



export default {
  list,
  get,
  add,
  update,
  destroy,
  last_no,
  update_bulk
};

